(() => {
  const timers = new WeakMap();
  const mount = (root) => {
    root.querySelectorAll('[data-halloween-sale-status]').forEach((section) => {
      if (timers.has(section)) return;
      const start = Date.parse(section.dataset.start);
      const end = Date.parse(section.dataset.end);
      if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) return;
      const update = () => {
        const now = Date.now();
        const phase = now >= end ? 'ended' : now >= start ? 'active' : 'before';
        section.querySelectorAll('[data-sale-phase]').forEach((text) => {
          text.hidden = text.dataset.salePhase !== phase;
        });
        section.querySelector('[data-sale-clock]').hidden = phase === 'ended';
      };
      update();
      const timer = window.setInterval(() => {
        if (!section.isConnected) {
          window.clearInterval(timer);
          timers.delete(section);
          return;
        }
        update();
      }, 1000);
      timers.set(section, timer);
    });
  };
  mount(document);
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
})();
